export default __webpack_public_path__ + "static/media/SAS0240.34I-38843_-22814_0.5c248e36.jpg";